import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './statistic-mark-line.reducer';

export const StatisticMarkLine = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'label'), props.location.search)
  );

  const statisticMarkLineList = useAppSelector(state => state.statisticMarkLine.entities);
  const loading = useAppSelector(state => state.statisticMarkLine.loading);
  const totalItems = useAppSelector(state => state.statisticMarkLine.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <PageHeader
        headingId="fleetSenseApp.statisticMarkLine.home.title"
        headingDataCy="StatisticMarkLineHeading"
        contentKey="fleetSenseApp.statisticMarkLine.home.title"
        buttonTextKey="fleetSenseApp.statisticMarkLine.home.createLabel"
        match={match}
      />
      <div className="table-responsive">
        {statisticMarkLineList && statisticMarkLineList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <DoNotShowInProduction>
                  <th className="hand" onClick={sort('id')}>
                    <Translate contentKey="fleetSenseApp.statisticMarkLine.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                  </th>
                </DoNotShowInProduction>
                <th className="hand" onClick={sort('label')}>
                  <Translate contentKey="fleetSenseApp.statisticMarkLine.label">Label</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('sensor.name')}>
                  <Translate contentKey="fleetSenseApp.statisticMarkLine.sensor">Sensor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.statisticMarkLine.value">Value</Translate>
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.statisticMarkLine.lineType">Line Type</Translate>
                </th>
                <DoNotShowInProduction>
                  <th>
                    <Translate contentKey="fleetSenseApp.statisticMarkLine.company">Company</Translate>
                  </th>
                </DoNotShowInProduction>
                <th />
              </tr>
            </thead>
            <tbody>
              {statisticMarkLineList.map((statisticMarkLine, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <DoNotShowInProduction>
                    <td>{statisticMarkLine.id}</td>
                  </DoNotShowInProduction>
                  <td>{statisticMarkLine.label}</td>
                  <td>{statisticMarkLine.sensor.name}</td>
                  <td>{statisticMarkLine.value}</td>
                  <td>
                    <div style={{ maxWidth: '100px', padding: '10px 0 0 0', borderBottom: `5px ${statisticMarkLine.lineType} ${statisticMarkLine.color}` }} />
                  </td>
                  <DoNotShowInProduction>
                    <td>{statisticMarkLine.company.name}</td>
                  </DoNotShowInProduction>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${statisticMarkLine.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${statisticMarkLine.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.statisticMarkLine.home.notFound">No Statistic Mark Lines found</Translate>
            </div>
          )
        )}
        {loading && <Loading />}
      </div>
      {totalItems ? (
        <div className={statisticMarkLineList && statisticMarkLineList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default StatisticMarkLine;
